import Modal from 'antd/lib/modal/Modal';
import React from 'react';
import { Button } from 'antd';
import './IncompleteOnboarding.scss'
import { useNavigate } from 'react-router-dom';

const IncompleteOnboarding = ({ visible, onClose,setShowOnboardingPopup }) => {
  const navigate = useNavigate()

  const handleNavigateCompleteSetup = () =>{
    localStorage.setItem('onboardingIncomplete',false);
    navigate('/sign-up/verification');
    setShowOnboardingPopup(false)
  }
 
  return (
    <Modal
      // title="Incomplete Onboarding"
      open={visible}
      footer={null}
      onclose={onClose}
      width={550}
      centered
      closable={false}
    >
      <h4 className='mb-20  text-center'>Your account setup is incomplete. Would you like to complete it now?</h4>
      <div className='modalBody'>
        <Button type="primary" onClick={handleNavigateCompleteSetup}>
          Complete Account Setup
        </Button>
        <Button onClick={onClose}>No,I'll do it later</Button>
      </div>
    </Modal>
  );
};

export default IncompleteOnboarding;